export const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

/**
 * English "a"/"an" for a noun based on its leading letter (vowel → "an").
 * Sufficient for labels like "student" / "employee"; not a full phonetics model.
 * @param {string} noun
 * @returns {string} e.g. "an employee", "a student"
 */
export const withIndefiniteArticle = (noun) => {
    const word = String(noun ?? '').trim();
    if (!word) {
        return word;
    }
    const article = /^[aeiou]/i.test(word) ? 'an' : 'a';
    return `${article} ${word}`;
};
